import { get } from 'lodash';

const root = state => get(state, 'MealEquivalentState.mealEquivalent');
export const getLoading = state => get(root(state), 'loading');
export const getFiscalYears = state => get(root(state), 'fiscalYears');
export const getGridData = state => get(root(state), 'gridData');
export const getIsAllChecked = state => get(root(state), 'isAllChecked');
export const getError = state => get(root(state), 'error');
export const getSaveSuccessful = state => get(root(state), 'saveSuccessful');
export const getSelectedFiscalYear = state =>
  get(root(state), 'selectedFiscalYear');



// WEBPACK FOOTER //
// ./src/pages/mealequivalentsetup/state/siteequivalent/selectors.js